import * as PopoverPrimitive from '@radix-ui/react-popover';
import { clsx } from 'clsx';
import { ReactNode } from 'react';
import { TooltipArrowIcon } from '../icons/react/tooltip-arrow.tsx';
import { useIsLaptop } from '../responsive/hooks.ts';
import { defaultTooltipContentRender } from '../tooltip/content-render.tsx';
import {
  tooltipArrow,
  tooltipContent,
  tooltipVariant,
} from '../tooltip/tooltip.css.ts';
import {
  Tooltip,
  TooltipContent,
  TooltipContentProps,
  TooltipTrigger,
} from '../tooltip/tooltip.tsx';
import { hintTrigger } from './hint.css.ts';

type HintProps = {
  children: ReactNode;
  color?: 'default' | 'prominent';
  className?: string;
  triggerClassName?: string;
  ref?: React.Ref<HTMLButtonElement>;
  delayDuration?: number;

  title?: string;
  description?: string;
  render?: TooltipContentProps['render'];
};

export const Hint = ({
  ref,
  className,
  triggerClassName,
  color = 'default',
  delayDuration = 100,
  title,
  description,
  render = defaultTooltipContentRender,
  children,
}: HintProps) => {
  const isLaptop = useIsLaptop();

  return isLaptop ? (
    <Tooltip delayDuration={delayDuration}>
      <TooltipTrigger ref={ref} className={clsx(hintTrigger, triggerClassName)}>
        {children}
      </TooltipTrigger>
      <TooltipContent
        color={color}
        className={className}
        title={title}
        description={description}
        render={render}
      />
    </Tooltip>
  ) : (
    <PopoverPrimitive.Root>
      <PopoverPrimitive.Trigger
        ref={ref}
        className={clsx(hintTrigger, triggerClassName)}
      >
        {children}
      </PopoverPrimitive.Trigger>
      <PopoverPrimitive.Portal>
        <PopoverPrimitive.Content
          collisionPadding={6}
          sideOffset={4}
          side="top"
          align="center"
          className={clsx(className, tooltipContent, tooltipVariant[color])}
        >
          {render({ title, description })}

          <PopoverPrimitive.Arrow
            className={clsx(tooltipArrow)}
            width={30}
            height={13}
            asChild
          >
            <TooltipArrowIcon width={30} height={13} viewBox="0 0 30 13" />
          </PopoverPrimitive.Arrow>
        </PopoverPrimitive.Content>
      </PopoverPrimitive.Portal>
    </PopoverPrimitive.Root>
  );
};
